import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const MenuBoardIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M7 7.5H14" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M7 11.5H11" />

		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M16 13.5L16.8 15.1L18.5 15.35L17.25 16.55L17.55 18.25L16 17.45L14.45 18.25L14.75 16.55L13.5 15.35L15.2 15.1L16 13.5Z"
		/>
	</SvgIcon>
)

export default MenuBoardIconAtom
